import axios from 'axios';
// import { Dialog } from 'vant';
// import Game from './Game'
import {Loading} from 'element-ui'
import {MessageBox,Message} from 'element-ui'
import Qs from 'qs';

let loadingInstance = {};

axios.defaults.baseURL = 'http://101.201.69.170:10000';
// 123.57.154.187:10043
// 192.168.1.143:10003
// 101.201.69.170:10001	协会测试
// 101.201.69.170:10010  内部测试
// 192.168.1.143:10002


//请求拦截器---即异常处理
axios.interceptors.request.use(config => {
	// console.log(config)
	// config.url = 'http://39.100.55.139:10001'+config.url;
	config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
	config.transformRequest = [function (data) {
		// 对 data 进行任意转换处理
		return Qs.stringify(data)
        // return data
    }];

    loadingInstance = Loading.service({
        lock: true,
        text: '正在加载...',
    });

	return config
 }, error => {

    loadingInstance.close();  // 关闭加载遮罩层
	MessageBox({
		message: '请求超时!',
		type:'info'
	}).catch(() => {
		
	});

	return Promise.reject(error)
});
  
  //响应拦截器---即异常处理
axios.interceptors.response.use(response => {
    loadingInstance.close();  // 关闭加载遮罩层
	return response
}, error => {
	if (error && error.response) {
	  switch (error.response.status) {
		case 400:
		  error.message = '错误请求'
		  break;
		case 401:
		//   error.message = '未授权，请重新登录';
		  error.message = '未授权，请重新验证';
		//   Router.replace('/login')
		  break;
		case 403:
		  error.message = '拒绝访问'
		  break;
		case 404:
		  error.message = '请求错误,未找到该资源'
		  break;
		case 405:
		  error.message = '请求方法未允许'
		  break;
		case 408:
		  error.message = '请求超时'
		  break;
		case 500:
		  error.message = '服务器开小差了~~'
		  break;
		case 501:
		  error.message = '网络未实现'
		  break;
		case 502:
		  error.message = '网络错误'
		  break;
		case 503:
		  error.message = '服务不可用'
		  break;
		case 504:
		  error.message = '网络超时'
		  break;
		case 505:
		  error.message = 'http版本不支持该请求'
		  break;
		default:
		  error.message = `连接错误${error.response.status}`
	  }
	} else {
	  console.log(error)
	  error.message = "连接到服务器失败"
	}
    
    MessageBox({
		message: error.message,
		type:'info'
	}).catch(() => {
		
	});
    loadingInstance.close(); // 关闭加载遮罩层
	return Promise.resolve(error.response)
})


export default {
	// ...Game,
	GetSeasonList(){//获取赛季接口
		return axios({
			url: '/GetSeasonList',
            method: 'GET',
			// data: {
			// 	SRUpdateDate: 'latest', 
			// }
		}).then(res=>{
			// console.log(res);
			return res.data;
		})
	},
    GetEventStatHome(ID){//获取首页9大统计数据接口
		return axios({
			url: '/GetEventStatHome',
            method: 'POST',
			data: {
				EventID: ID, 
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetPhaseList(ID){//获取阶段列表接口
		return axios({
			url: '/GetPhaseList',
            method: 'POST',
			data: {
				EventID: ID, 
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetMatchResultList(PhaseID,TeamID){//获取比赛成绩列表
		return axios({
			url: '/GetMatchResultList',
            method: 'POST',
			data: {
				PhaseID: PhaseID, 
				TeamID: TeamID,
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetEventStatList(SportID,Type,a,PageSize){//获取9大统计数据列表
		return axios({
			url: '/GetEventStatList',
            method: 'POST',
			data: {
				EventID: SportID, 
				Type: Type,
				PageIndex: a,
				PageSize: PageSize,
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetGroupResult(PhaseID){//获取小组赛积分成绩
		return axios({
			url: '/GetGroupResult',
            method: 'POST',
			data: {
				PhaseID: PhaseID,
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetSportTeamList(EventID){//获取队伍列表
		return axios({
			url: '/GetSportTeamList',
            method: 'POST',
			data: {
				EventID: EventID,
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetPlayerAll(url,EventID,Position){//最佳阵容-接口
		return axios({
			url: url,
            method: 'POST',
			data: {
				EventID: EventID,
				Position: Position,
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
	GetTeamDetail(url,EventID){//获取队伍详细信息-接口
		return axios({
			url: url,
            method: 'POST',
			data: {
				EventID: EventID,
			}
		}).then(res=>{
			// console.log(res.data);
			return res.data;
		})
	},
}